import React from "react";
import { ICourse } from "../../../../features/courses/coursesSlice";
import { StatusEnum } from "../../../common/Status";
import { IconNames } from "../../common/SimpleStat";
import { StatsRow } from "../../common/StatsRow";
import { getTranslations } from "../../../../features/translations/translationsUtils";

interface Props {
  courses: ICourse[];
  totalResources: string;
  totalEnabledResources: string;
}

export const EducationalResourcesStats: React.FunctionComponent<Props> = ({
  courses,
  totalResources,
  totalEnabledResources,
}) => {
  const stats = [
    {
      description: getTranslations('REPORT_AVAILABLE_COURSES'),
      iconName: IconNames.Frequency,
      mainText:
        courses
          .filter((course) => course.status === StatusEnum.Enable)
          .reduce((total: number, course) => total + course.durationHour, 0) +
        " horas",
    },
    {
      description: getTranslations('REPORT_CREATED_CONTENT'),
      iconName: IconNames.RegisteredResources,
      mainText: totalResources,
    },
    {
      description: getTranslations('REPORT_ENABLED_CONTENT'),
      iconName: IconNames.EnabledResources,
      mainText: totalEnabledResources,
    },
  ];
  return <StatsRow statsData={stats} />;
};
